import { useDispatch, useSelector } from 'react-redux'
import { ROUTE_USER_ACCOUNT } from '../../routes'
import { navigateTo } from '../../store/history/history.actions'
import { MODAL_IDS, USER_SCREENS } from '../../store/ui/ui.constants'
import { setUiUserScreen } from '../../store/ui/uiSlice'
import { selectIsUserConnected } from '../../store/userAccount/userAccount.selectors'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import useModal from '../ui/useModal'
import { useAction } from '../utils/react-redux'
import { addDatadogRumError } from '../rum/DataDogRum'

const useIncentiveClick = ({ onClick, incentiveTagClickBuilder }) => {
  const dispatch = useDispatch()
  const isConnected = useSelector(selectIsUserConnected)
  const { displayModal } = useModal(MODAL_IDS.USER_ACCOUNT_INCENTIVE_POPIN)
  const configureAndSendTag = useConfigureAndSendTag()
  const execNavigateTo = useAction(navigateTo)
  const manageFavorite = type => dispatch(setUiUserScreen({ name: USER_SCREENS.manageFavorite, params: { type } }))

  const onIncentiveClick = suggest => {
    if (!suggest) {
      addDatadogRumError('Click on undefined suggest')
      return
    }
    const { incentive, type } = suggest
    if (!incentive) {
      onClick(suggest)
    } else if (isConnected) {
      configureAndSendTag(incentiveTagClickBuilder(suggest))
      manageFavorite(type)
      execNavigateTo({ route: ROUTE_USER_ACCOUNT })
    } else {
      displayModal()
      configureAndSendTag(incentiveTagClickBuilder(suggest))
    }
  }

  return { onIncentiveClick }
}

export default useIncentiveClick
